import { createReplicate } from "@ai-sdk/replicate";
import { envVariables } from "@/lib/envVariables";

/**
 * Replicate provider configuration
 */
export const replicate = createReplicate({
  apiToken: envVariables.REPLICATE_API_KEY,
});

/**
 * Model ID constants for Replicate models
 */
export const QWEN_IMAGE_MODEL = "qwen/qwen-image";

/**
 * Helper function to get Replicate provider with Qwen image model
 */
export const qwenImage = () => replicate.image(QWEN_IMAGE_MODEL);
